import { Injectable } from '@angular/core';
import { MemeState } from '../interfaces/memestate.interface';
import { State } from '../interfaces/state.interface';

@Injectable({
  providedIn: 'root',
})
export class MemeTriggerService {
  checkMemes(state: State): MemeState {
    let memeState: MemeState = JSON.parse("{}");

    memeState.similarVote =
      state.VoteMap.deviation == 0 &&
      state.VoteMap.voteFrequencyMap.size == 1 &&
      state.Players.length === state.VoteMap.voteFrequencyMap.get(state.VoteMap.mostVotedCardKey
    );

    return memeState;
  }
}
